import { createContext } from "react";

export type RatesType = Record<string, number>;

export type MarketData = {
  id: string;
  symbol: string;
  name: string;
  image: string;
  current_price: number;
  market_cap: number;
  market_cap_rank: number;
  total_volume: number;
  price_change_24h: number;
  price_change_percentage_24h: number;
  sparkline_in_7d: { price: number[] };
};

export const RatesContext = createContext<{
  rates: RatesType;
  isLoading: boolean;
  marketData: MarketData[];
}>({
  rates: {},
  isLoading: true,
  marketData: [],
});
